import { inject } from '@angular/core';
import { CanActivateFn, RedirectCommand, Router } from '@angular/router';
import { DashboardProfileContextService } from '@rma/dashboard/authentication/public/user';
import { combineLatest, map, take } from 'rxjs';

export function isAgencyGuard(redirectTo = '/'): CanActivateFn {
  return () => {
    const router = inject(Router);
    const profileContextService = inject(DashboardProfileContextService);

    return combineLatest({
      isOffice: profileContextService.isOffice$,
      isTeam: profileContextService.isTeam$,
    }).pipe(
      take(1),
      map(({ isOffice, isTeam }) => {
        if (isOffice || isTeam) {
          return true;
        }

        return new RedirectCommand(router.parseUrl(redirectTo), {
          skipLocationChange: false,
        });
      }),
    );
  };
}
